import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslations } from 'next-intl';

export const useProcessOverview = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const t = useTranslations('processOverview');

  const isEven = (index: number) => index % 2 === 0;

  const handleClick = useCallback(
    (index: number) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setActiveIndex(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const processOverviewConfig = Array.from({ length: 5 }, (_, index) => {
    const stepNumber = index + 1;

    return {
      title: t(`subHeading${stepNumber}`),
      description: t(`subDescription${stepNumber}`),
    };
  });

  return {
    t,
    isEven,
    activeIndex,
    handleClick,
    containerRef,
    processOverviewConfig,
  };
};
